import { render, staticRenderFns } from "./endorseReplace.vue?vue&type=template&id=fead8cbc&scoped=true&"
import script from "./endorseReplace.vue?vue&type=script&lang=js&"
export * from "./endorseReplace.vue?vue&type=script&lang=js&"
import style0 from "./endorseReplace.vue?vue&type=style&index=0&id=fead8cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fead8cbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fead8cbc')) {
      api.createRecord('fead8cbc', component.options)
    } else {
      api.reload('fead8cbc', component.options)
    }
    module.hot.accept("./endorseReplace.vue?vue&type=template&id=fead8cbc&scoped=true&", function () {
      api.rerender('fead8cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/endorseReplace.vue"
export default component.exports